<template>
  <div class="main">
  </div>
</template>

<script>
// import axios from 'axios'
import { mc } from './../assets/mc.js'
// import wx from 'weixin-js-sdk'
export default {
  name: 'YsgfAuthPage',  //越上高峰免登页面
  props: {
  },
  data () {
    return {
      inwx: false,
      inyn: false,
      info: "",
      url: "",
      status: null,
      pageType: ''
    }
  },
  created () {
    var ptype = this.getQueryVariable('pageType')
    this.pageType = ptype ? ptype : ''
    document.addEventListener("visibilitychange",() => {
      this.status = document.visibilityState
    })
    
  },
  mounted () {
    if (mc.isClient()) {
      this.inyn = true
      this.login()
    } else {
      location.replace("https://m.shaoxing.com.cn/ysgfhx?pageType=999")
    }
  },
  computed: {
  },
  methods: {
    login() {
      mc.userGetEncryptInfo((data) => {
        if (data['state']) {
          mc.userGetInfo((data1) => {
            location.replace(`https://bbs.sxnews.cn/auth/ysgf?userid=${data['data']['userid']}&nickname=${data1['data']['nickname']}&avatar=${encodeURIComponent(data1['data']['avatar'])}&noncestr=${data['data']['nonce']}&timestamp=${data['data']['timestamp']}&sign=${data['data']['signature']}&pageType=${this.pageType}`)
          })
        } else {
          mc.reLogin(() => {
            this.login()
          })
        }
      })
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split("&")
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=")
        if(pair[0] == variable){return pair[1]}
      }
      return(false)
    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: underline;
}
.main {
  width: 100%;
  height: 100vh;
  position: relative;
}
.main img {
  width: 100%;
  display: block;
}
.main .iframe {
  width: 100%;
  height: 100%;
}
#launch {
  position: absolute;
  left: 50%;
  bottom: 20%;
  width: 50vw;
  height: 12.4vw;
  max-width: 484px;
  max-height: 120px;
  transform: translate(-50%,-50%);
  background-image: url('//res.shaoxing.com.cn/a/10001/202308/3e86949858c5d3343b7dc9c80d381462.png');
  background-repeat: no-repeat;
  border: unset;
  background-color: transparent;
  background-size: 100%;z-index: 100;
}
</style>
